import { AddressBookOrder } from "src/views/AssetManagement/Swap/types";

type AddRecipientFields = {
  addressBookOrder: AddressBookOrder;
  riskType: string;
  probability: string;
  rawWalletInfo: any;
};

const initAddRecipientFields: AddRecipientFields = {
  addressBookOrder: {
    to_address: "",
    amount: "",
    display_name: "",
    wallet_type: "",
    to_wallet_tag: "",
    rawItem: undefined,
  },
  riskType: "",
  rawWalletInfo: {},
  probability: "",
};

export { type AddRecipientFields, initAddRecipientFields };
